import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../authentication/services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuardService implements CanActivateChild {
  failAttemps = 0;
  constructor(private authSvc: AuthenticationService, private router: Router) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const getPerm: string = this.authSvc.getPermissions();

    if (!getPerm || getPerm === 'undefined') {
      return false;
    }

    const permissions = JSON.parse(getPerm);
    let url = '';
    let slashCount = 0;

    const isNew = state.url.indexOf('/new');
    const isEdit = state.url.indexOf('/edit');
    const isAdmin = state.url.indexOf('/admin');

    if (isNew !== -1) {
      url = this.getIdItem(state.url);
    } else if (isEdit !== -1) {
      url = this.getIdItem(state.url);
    } else {
      for (const i of state.url) {
        if (i === '/') {
          slashCount++;
        }
      }
      url = state.url;
    }

    if (permissions) {
      if (permissions.length === 0) {
        return false;
      } else {
        const perm = permissions.find(
          (x: { keyName: string; actions: string[] }) =>
            url.indexOf(x.keyName) !== -1
        );
        if (perm) {
          console.log('IS NEW AND IS EDIT', isEdit, isNew, url, slashCount);
          if (
            isNew !== -1 &&
            perm.actions.find((fd: string) => fd === 'create')
          ) {
            //valid if route is new and find perm create
            console.log('IS NEW');
            return true;
          } else if (
            isEdit !== -1 &&
            perm.actions.find((fd: string) => fd === 'update')
          ) {
            //valid if route is edit and find perm update
            console.log('IS EDIT');
            return true;
          } else if (
            slashCount === 2 &&
            perm.actions.find((fd: string) => fd === 'detail')
          ) {
            //valid if route is list
            console.log('IS DETAIL');
            return true;
          } else if (
            perm.actions.find((fd: string) => fd === 'list') &&
            isEdit === -1 &&
            isNew === -1
          ) {
            //valid if route is list
            console.log('IS LIST');
            return true;
          } else if (
            perm.keyName === 'createTransaction' &&
            perm.actions.length > 0
          ) {
            //valid if have permission of create or admin
            console.log('IS NEW TRANSACTION MODULE');
            return true;
          }
        }
        console.log('NOT PERMISSIONS');
        this.router.navigate(['/dashboard']);
        return false;
      }
    } else {
      console.log('LOGOUT, NOT PERMISSIONS');
      this.router.navigate(['/auth/login']);
      return false;
    }
  }

  getIdItem(str: string) {
    const pos = str.lastIndexOf('/');
    const res = str.substring(0, pos);
    return res;
  }

  getIdEdit(str: string) {
    const pos = str.lastIndexOf('/');
    const id = str.substring(pos + 1, str.length);
    return id.length;
  }

  getSecondIdItem(str: string) {
    const pos = str.lastIndexOf('/');
    const subs = str.substring(0, pos);
    const posTwo = subs.lastIndexOf('/');
    const res = subs.substring(0, posTwo);
    return res;
  }
}
